import { User } from "../../Utilities";

export enum ControlledEventType {
	Birthdays = "Birthdays",
}

export type BirthdayEventAdditional = {
	name: string;
	shortName: string;
	dateOfBirth: Date;
	isStudent: boolean;
};

export type CalendarItemGroup = {
	id: string;
	name: string;
	color: string;
	_isControlled?: boolean;
};

export type EventCalendarItem = {
	id: string;
	name: string;
	description: string;
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	endDate: string | null;
	isPublic: boolean;
	groups?: CalendarItemGroup[];
	author?: Pick<User, "id" | "isCurrent"> | null;
	_isControlled?: boolean;
	_additional?: any;
};

export type EventTooltipProps = {
	item: EventCalendarItem;
	isOpen: boolean;
	synchronizeContent: () => void;
	withModalBackButton: boolean;
	setIsModalOpen: (value: boolean) => void; // TODO better handling for nested opening with useClickOutListener
	noStem?: boolean;
	className?: string;
	style?: React.CSSProperties;
	modalVariant?: "default" | "admin";
};
